module.exports = __webpack_public_path__ + "static/media/redo.47293024.svg";